
import Component from '../../../assets/scripts/modules/component';
import Pikaday from 'pikaday';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';

const STATE_INITIAL = 0;
const STATE_PICK_DATE = 1;
const STATE_PICK_CALENDAR = 2;

function getLocale() {
  const locale = document.querySelector('html').getAttribute('lang') || 'es';
  if (locale === 'en') {
    return {
      previousMonth : 'Previous Month',
      nextMonth     : 'Next Month',
      months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
      weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
    }
  }
  return {
    previousMonth : 'Mes anterior',
    nextMonth     : 'Mes siguiente',
    months        : ['Enero','Febrero','Marzo','April','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    weekdays      : ['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'],
    weekdaysShort : ['Dom','Lun','Mar','Mie','Jue','Vie','Sab']
  }
}

function formatDate(date) {
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}

class AddToCalendar extends Component {
  init() {
    window.addEventListener('add-to-calendar:start', (event) => {
      this.startFlow(event.detail);
    });

    [...this.element.querySelectorAll('.add-to-calendar__step')].forEach((element) => {
      element.addEventListener('click', () => {
        event.stopPropagation();
      });
    });

    window.addEventListener('lightbox:hidden', (event) => {
      if (event.detail.id === 'add-to-calendar') {
        this.endFlow();
      }
    });

    this.updateState(STATE_INITIAL);
  }

  startFlow(eventData) {
    fireCustomEvent('lightbox:show', {id: 'add-to-calendar'});
    this.initializeEventDate();
    Object.assign(this.eventData, eventData);
    this.updateState(STATE_PICK_DATE);
    this.initializeDatePicker();
    this.element.style.width = `${this.element.getBoundingClientRect().width}px`;
    this.element.style.height = `${this.element.getBoundingClientRect().height}px`;
  }

  endFlow() {
    if (this.state >= STATE_PICK_DATE) {
      this.picker.destroy();
    }

    this.updateState(STATE_INITIAL);
  }

  dateSelected(date) {
    this.eventData.date = date;
    this.setCalendarEventDate();
    this.updateState(STATE_PICK_CALENDAR);
  }

  initializeEventDate() {
    this.eventData = {
      minDate: new Date(),
      maxDate: new Date(new Date() * 1 + 1000 * 60 * 60 * 24 * 365),
      title: 'No title specified',
      description: 'No description specified',
    };
  }

  initializeDatePicker() {
    this.picker = new Pikaday({
      defaultDate: this.eventData.minDate > new Date() ? this.eventData.minDate : (this.eventData.maxDate > new Date() ? new Date() : this.eventData.maxDate),
      i18n: getLocale(),
      minDate: this.eventData.minDate,
      maxDate: this.eventData.maxDate,
      onSelect: this.dateSelected.bind(this),
    });

    this.element.querySelector('[data-role=add-to-calendar--date-picker]').appendChild(this.picker.el);
  }

  setCalendarEventDate() {
    const eventElements = [...this.element.querySelectorAll('.addeventatc')];

    eventElements.forEach((eventElement) => {
      eventElement.querySelector('.start').innerText = formatDate(this.eventData.date);
      eventElement.querySelector('.end').innerText = formatDate(this.eventData.date);
      eventElement.querySelector('.title').innerText = document.querySelector('[data-role=add-to-calendar]').getAttribute('data-title');
      eventElement.querySelector('.description').innerText = document.querySelector('[data-role=add-to-calendar]').getAttribute('data-description');
    });

    window.addeventatc.refresh();
  }

  updateState(state) {
    this.state = state;
    this.element.setAttribute('data-state', state);
  }
}

for (const element of document.querySelectorAll('.add-to-calendar')) {
  element.instance = new AddToCalendar('add-to-calendar', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/structures/add-to-calendar/add-to-calendar.js